import React from 'react'
import "../styles/styles.css"

export default function About() {
    return (
        <>
        <div className="about-sec">
           <h1>Welcome to About Page</h1> 
           <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci incidunt corporis voluptas velit magni animi placeat in ullam vel quo, odit, deleniti eligendi vero minus explicabo cumque facilis! Atque, sapiente.
           </p>
           <blockquote>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Beatae, praesentium eos. Nisi exercitationem amet aliquam repudiandae natus, officia similique, cupiditate animi et aut nesciunt enim labore, est saepe laudantium corrupti.</blockquote>
        </div>
        <div className="back-btn">
        <a href="/"><button>Back to shop</button></a>
        </div>
        
        </>
    )
}
